
import TextField from "@material-ui/core/TextField";
import { InputTextarea } from "primereact/inputtextarea";

import React, { useState, useEffect, useRef } from 'react';
import { AutoComplete } from 'primereact/autocomplete';


function TextInputCharacter(props) {
    const [stadoVal, setStateVal] = useState(props.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        const regex = /[^0-9a-zA-ZáéíóúÁÉÍÓÚñÑ?¿,.\s]/g;
        setStateVal(newValue.replace(regex, ''))

    };

    return (

        <InputTextarea
            autoResize
            {...props}
            id={props.name}
            name={props.name}
            disabled={props.disabled}
            placeholder={props.placeholder}
            value={stadoVal}
            onChange={onChange}

        />
    )

}


function OnlyTextInput(props) {
    const [stadoVal, setStateVal] = useState(props.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        if (newValue.match(/^([A-Za-z0-9\s]*)+$/) || newValue.length === 0) {
            setStateVal(newValue); // only set when successful
        }

    };

    return (
        <TextField
            {...props}
            id={props.name}
            name={props.name}
            disabled={props.disabled}
            placeholder={""}
            value={stadoVal}
            onChange={onChange}
        />
    )

}

function AutoCompleteDemo(props) {

    const [countries, setCountries] = useState([]);
    const [selectedCountry2, setSelectedCountry2] = useState("");
    const [filteredCountries, setFilteredCountries] = useState(null);





    useEffect(() => {
        console.log(props.name, props.options)
        setCountries(props.options)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const searchCountry = (event) => {
        setTimeout(() => {
            let _filteredCountries;
            if (!event.query.trim().length) {
                _filteredCountries = [...countries];
            }
            else {
                _filteredCountries = countries.filter((country) => {
                    return country.label.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCountries(_filteredCountries);
        }, 50);
    }

    return (
        <AutoComplete
            value={selectedCountry2}
            suggestions={filteredCountries}
            completeMethod={searchCountry}
            field="label"
            dropdown
            onChange={(e) => setSelectedCountry2(e.value)}
            aria-label="Countries"
            dropdownAriaLabel={props.placeholder}

            {...props}
            id={props.name}
            name={props.name}
            disabled={props.disabled}
            placeholder={props.placeholder}
        />

    )
}
function MyComponentCapcha({ sitekey, onChange, id, disabled }) {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);

    useEffect(() => {
        let isMounted = true;
        const scriptId = 'google-recaptcha-enterprise-script';

        const renderWidget = () => {
            if (!isMounted || !containerRef.current) return;
            if (window.grecaptcha && window.grecaptcha.enterprise) {
                if (widgetIdRef.current === null) {
                    try {
                        containerRef.current.innerHTML = '';
                        widgetIdRef.current = window.grecaptcha.enterprise.render(containerRef.current, {
                            sitekey: sitekey,
                            callback: (token) => {
                                if (onChange) onChange(token);
                            },
                            'expired-callback': () => {
                                if (onChange) onChange(null);
                            },
                            'error-callback': () => {
                                if (onChange) onChange(null);
                            }
                        });
                    } catch (e) {
                        console.error('Error al renderizar reCAPTCHA Enterprise:', e);
                    }
                }
            }
        };

        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                if (window.grecaptcha && window.grecaptcha.enterprise) {
                    window.grecaptcha.enterprise.ready(renderWidget);
                }
            };
            document.body.appendChild(script);
        } else {
            if (window.grecaptcha && window.grecaptcha.enterprise) {
                window.grecaptcha.enterprise.ready(renderWidget);
            }
        }

        return () => {
            isMounted = false;
        };
    }, [sitekey, onChange]);

    return <div ref={containerRef} id={id} className="enterprise-recaptcha" />;
}




export { TextInputCharacter, AutoCompleteDemo, OnlyTextInput, MyComponentCapcha };